import ms181 from "./ms-181";
import ms182 from "./ms-182";
import ms183 from "./ms-183";

export default { ms181, ms182, ms183 };
